module.exports = __webpack_public_path__ + "static/media/insert.2b12e8b6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/insert.gif
// module id = 429
// module chunks = 0